import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-full h-auto border rounded-md overflow-hidden" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "flex py-4 space-x-4 ml-3" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "flex justify-around space-x-20" }
const _hoisted_6 = { class: "font-bold truncate text-base" }
const _hoisted_7 = { class: "text-gray-400" }

import { ref, withDefaults } from "vue";
import axios from "axios";
import PhotoPopup from "@/components/PhotoPopup.vue";

import DownloadIcon from "@/components/icons/Download.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    img: {},
    name: {},
    attrib: {},
    imgcap: {},
    id: {},
    img_large: {},
    photographer_ur: {}
  },
  setup(__props: any) {

const props = __props;



const showImagePopup = ref(false);

// methods
function getDownload() {
  axios({
    url: `${props.img}`,
    method: "GET",
    responseType: "blob",
  }).then((response) => {
    var fileUrl = window.URL.createObjectURL(new Blob([response.data]));
    var fileLink = document.createElement("a");
    fileLink.href = fileUrl;

    fileLink.setAttribute("download", "pexelry download.jpeg");
    document.body.appendChild(fileLink);
    fileLink.click();
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "w-full h-80 hover:cursor-pointer",
        src: _ctx.img_large,
        alt: _ctx.attrib,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showImagePopup.value = true))
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.photographer_ur) + " ", 1),
        _createElementVNode("img", {
          class: "h-12 w-12 rounded-full",
          src: _ctx.img,
          alt: _ctx.attrib
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.name.length > 10 ? _ctx.name.slice(0, _ctx.name.length - 6) : _ctx.name), 1),
            _createElementVNode("span", _hoisted_7, " @" + _toDisplayString(_ctx.name.length > 10 ? _ctx.name.slice(0, _ctx.name.length - 6) : _ctx.name), 1)
          ]),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (getDownload())),
            class: "w-6 h-6 rounded-full text-center cursor-pointer"
          }, [
            _createVNode(DownloadIcon)
          ])
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (showImagePopup.value)
        ? (_openBlock(), _createBlock(PhotoPopup, {
            key: 0,
            image: props.img_large,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (showImagePopup.value = false))
          }, null, 8, ["image"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})